import { Metamodel } from '../base/model';
import { Activity, IAttribute, ModelConstants, FMLVLinkedService } from 'shell-models-lib';
import { WebExtensibleUtil } from 'app/shared/utils/web-extensible.util';

@Metamodel.model({
    name: ModelConstants.materializedViewActivity,
    referable: true
})
export class RefreshMaterializedLakeViewActivity extends Activity {

    public static readonly LAKEHOUSEID: IAttribute;
    public static readonly WORKSPACEID: IAttribute;
    
    @Metamodel.attribute({
        display: stringResources.ConnectionLabel,
        constraint: {
            required: true,
            validator: WebExtensibleUtil.validateConnection
        },
        reference: true,
    })
    public linkedService?: FMLVLinkedService;

    @Metamodel.attribute({
        reference: true,
        association: 'LAKEHOUSEID',
        constraint: {
            required: true
        },
        templatable: true
    })
    public lakehouseId?: string;

    @Metamodel.attribute({
        reference: true,
        association: 'WORKSPACEID',
        constraint: {
            required: true
        },
        templatable: true
    })
    public workspaceId?: string;

}